export const CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE'
export const SET_OFFERS = 'SET_OFFERS'
export const SET_PARAMS = 'SET_PARAMS'
export const SET_MAP = 'SET_MAP'
export const SET_CURRENT_OFFER = 'SET_CURRENT_OFFER'
